import * as types from './mutation-types';
import EventBus from '@/utils/eventBus';
import orderService from '@/services/order';

export const getOrders = async ({ commit, state }, filter) => {
  EventBus.$emit('show-loading', true);

  if (!filter && state.lastFilter) {
    filter = state.lastFilter;
  }

  const res = await orderService.get(filter);

  let removeLimit = null;
  if (filter.filter.where) {
    removeLimit = {
      where: filter.filter.where,
    };
  }

  const count = await orderService.count(removeLimit);

  EventBus.$emit('show-loading', false);
  commit(types.GET_ORDER, {
    lastFilter: filter,
    orders: res.data,
    count: count.data.count,
  });
};

export default {
  getOrders,
};



// WEBPACK FOOTER //
// ./src/store/modules/order/actions.js